import React from 'react';
import SkillRoboLogo from '../../images/skillrobo-logo-white.png';

const SkillRoboWhiteLogo = () => <img src={SkillRoboLogo} alt="skillrobo" />;

export default SkillRoboWhiteLogo;
